import React, {useContext} from 'react';
import {Route} from 'react-router';
import {Redirect, Switch} from 'react-router-dom';

import {NavContext, NavRoutes} from '../contexts';

import {AuthenticatedTemplate, UnauthenticatedTemplate, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig.js";

import {
    CompetenzaPage,
    CompetenzePage,
    ComuneCompetenzaPage,
    ComunePage,
    ComuniPage,
    ContattiWizardPage,
    ContattoPage,
    ImpostazionePage,
    ProvincePage,
    ProvinciaPage,
    RegionePage,
    RegioniPage,
    StoricoUfficioComuneCompetenzaPage,
    StoricoUfficioPage,
    TipiContattiPage,
    TipiUfficiPage,
    TipoContattoPage,
    TipoUfficioPage,
    UfficioPage,
    UfficiPage,
    UtentePage,
    UtentiPage
} from '../pages';

import {Container, Typography} from '@mui/material';

const ProtectedRoute = ({...props}) => {
    const {instance, accounts} = useMsal();

    const handleLogin = () => {
        instance.loginRequest = loginRequest;
        instance.loginRedirect();
    }

    const boxSX = {
        color: "whitesmoke",
        backgroundColor: 'secondary.main',

        "&:hover": {
            backgroundColor: 'secondary.light',

            //backgroundColor: 'lightblue'
        },
    };

    return <>
        <AuthenticatedTemplate>
            <Route {...props} />
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
            <Container>
                <Container>
                    <center>
                        <Typography>
                            Benvenuto nel portale di gestione di Giustizia Map del Ministero della Giustizia
                        </Typography>
                    </center>
                    <UnauthenticatedTemplate>
                        <center>
                            <Typography>
                                Per proseguire effettua l'accesso con ADN, SPID, CIE o CNS
                            </Typography>
                        </center>
                    </UnauthenticatedTemplate>
                </Container>
            </Container>
        </UnauthenticatedTemplate>
    </>
};

export const Routes = ({...props}) => {
    const {menuItems} = useContext(NavContext);

    return (

        <Switch>
            <Route exact path="/">
                <Redirect to="/amministrazione"/>
            </Route>
            {menuItems && menuItems.map((item, index) => {
                return <Route key={index} exact path={item.routePath} component={item.component}/>
            })}
            <ProtectedRoute exact path={NavRoutes.Competenze} component={CompetenzePage}/>
            <ProtectedRoute exact path={NavRoutes.Competenza} component={CompetenzaPage}/>
            <ProtectedRoute exact path={NavRoutes.CompetenzaAdd} component={CompetenzaPage}/>
            <ProtectedRoute exact path={NavRoutes.Comuni} component={ComuniPage}/>
            <ProtectedRoute exact path={NavRoutes.Comune} component={ComunePage}/>
            <ProtectedRoute exact path={NavRoutes.ComuneAdd} component={ComunePage}/>
            <ProtectedRoute exact path={NavRoutes.ComuneCompetenza} component={ComuneCompetenzaPage}/>
            <ProtectedRoute exact path={NavRoutes.ComuneCompetenzaAdd} component={ComuneCompetenzaPage}/>
            <ProtectedRoute exact path={NavRoutes.TipiUffici} component={TipiUfficiPage}/>
            <ProtectedRoute exact path={NavRoutes.TipoUfficio} component={TipoUfficioPage}/>
            <ProtectedRoute exact path={NavRoutes.TipoUfficioAdd} component={TipoUfficioPage}/>
            <ProtectedRoute exact path={NavRoutes.TipiContatti} component={TipiContattiPage}/>
            <ProtectedRoute exact path={NavRoutes.TipoContatto} component={TipoContattoPage}/>
            <ProtectedRoute exact path={NavRoutes.TipoContattoAdd} component={TipoContattoPage}/>
            <ProtectedRoute exact path={NavRoutes.Uffici} component={UfficiPage}/>
            <ProtectedRoute exact path={NavRoutes.Ufficio} component={UfficioPage}/>
            <ProtectedRoute exact path={NavRoutes.UfficioAdd} component={UfficioPage}/>
            <ProtectedRoute exact path={NavRoutes.StoricoUfficio} component={StoricoUfficioPage}/>
            <ProtectedRoute exact path={NavRoutes.StoricoUfficioComuneCompetenza}
                            component={StoricoUfficioComuneCompetenzaPage}/>
            <ProtectedRoute exact path={NavRoutes.Contatto} component={ContattoPage}/>
            <ProtectedRoute exact path={NavRoutes.ContattoAdd} component={ContattoPage}/>
            <ProtectedRoute exact path={NavRoutes.Province} component={ProvincePage}/>
            <ProtectedRoute exact path={NavRoutes.Provincia} component={ProvinciaPage}/>
            <ProtectedRoute exact path={NavRoutes.ProvinciaAdd} component={ProvinciaPage}/>
            <ProtectedRoute exact path={NavRoutes.Regioni} component={RegioniPage}/>
            <ProtectedRoute exact path={NavRoutes.Regione} component={RegionePage}/>
            <ProtectedRoute exact path={NavRoutes.RegioneAdd} component={RegionePage}/>
            <ProtectedRoute exact path={NavRoutes.Utenti} component={UtentiPage}/>
            <ProtectedRoute exact path={NavRoutes.Utente} component={UtentePage}/>
            <ProtectedRoute exact path={NavRoutes.UtenteAdd} component={UtentePage}/>
            <ProtectedRoute exact path={NavRoutes.Impostazione} component={ImpostazionePage}/>
            <ProtectedRoute exact path={NavRoutes.ContattiWizard} component={ContattiWizardPage}/>

        </Switch>
    );
}